import React, { useState } from "react";
import { deletePlayerListing, markPlayerListingSold, reactivatePlayerListing } from "../lib/playerListings";
import { T } from "../theme";
import { Badge, Btn, Card, fmt, SectionTitle, TapeIcon } from "../ui";

export default function PlayerListingDetailScreen({ listing, isMine, onBack }) {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const photos = listing.photoUrls || [];
  const [activePhotoIndex, setActivePhotoIndex] = useState(0);

  const remove = async () => {
    setBusy(true);
    try {
      await deletePlayerListing(listing.id);
      onBack();
    } finally {
      setBusy(false);
    }
  };

  const toggleSold = async () => {
    setBusy(true);
    try {
      if (listing.status === "sold") await reactivatePlayerListing(listing.id);
      else await markPlayerListingSold(listing.id);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <Card style={{ background: `linear-gradient(135deg,${T.surface},${T.card})`, textAlign: "center", padding: "24px 16px" }}>
        {photos.length > 0 ? (
          <img src={photos[activePhotoIndex]} alt="" style={{ width: 160, height: 160, objectFit: "cover", borderRadius: 10, border: `1px solid ${T.border}` }} />
        ) : (
          <TapeIcon size={80} />
        )}
        {photos.length > 1 && (
          <div style={{ display: "flex", justifyContent: "center", gap: 6, marginTop: 10, flexWrap: "wrap" }}>
            {photos.map((url, i) => (
              <img
                key={i}
                src={url}
                alt=""
                onClick={() => setActivePhotoIndex(i)}
                style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 6, cursor: "pointer", border: `2px solid ${i === activePhotoIndex ? T.accent : "transparent"}`, opacity: i === activePhotoIndex ? 1 : 0.7 }}
              />
            ))}
          </div>
        )}
        <div style={{ fontSize: 22, fontWeight: "bold", color: T.text, marginTop: 12 }}>{listing.brand} {listing.model}</div>
        <div style={{ fontSize: 12, color: T.muted, marginTop: 4 }}>{listing.era}</div>
        <div style={{ marginTop: 10, display: "flex", justifyContent: "center", gap: 8, flexWrap: "wrap" }}>
          {listing.condition && <Badge condition={listing.condition} />}
          <span style={{ fontSize: 9, background: T.statBg, border: `1px solid ${T.border}`, color: T.accent, fontWeight: "bold", padding: "2px 7px", borderRadius: 4 }}>{listing.powerStatus}</span>
          {listing.status === "sold" && <span style={{ fontSize: 9, background: T.border, color: T.muted, padding: "2px 7px", borderRadius: 4 }}>SOLD</span>}
        </div>
      </Card>

      <Card style={{ textAlign: "center" }}>
        <div style={{ fontSize: 9, color: T.muted, letterSpacing: "0.15em", textTransform: "uppercase" }}>Asking Price</div>
        <div style={{ fontSize: 24, fontWeight: "bold", color: T.value, marginTop: 4 }}>{fmt(listing.price)}</div>
      </Card>

      <SectionTitle>Description &amp; Contact</SectionTitle>
      <Card><div style={{ fontSize: 13, color: T.muted, lineHeight: 1.7 }}>{listing.description}</div></Card>

      {!isMine && (
        <div style={{ fontSize: 10, color: T.muted, textAlign: "center", marginTop: 4 }}>
          Payments and shipping are arranged directly between collectors.
        </div>
      )}

      {isMine && confirming ? (
        <Card style={{ textAlign: "center" }}>
          <div style={{ fontSize: 13, color: T.text, marginBottom: 12 }}>Remove this listing? This cannot be undone.</div>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn variant="outline" onClick={() => setConfirming(false)} style={{ flex: 1 }}>Cancel</Btn>
            <Btn variant="danger" disabled={busy} onClick={remove} style={{ flex: 1 }}>{busy ? "Removing…" : "Remove"}</Btn>
          </div>
        </Card>
      ) : (
        <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
          <Btn variant="outline" onClick={onBack} style={{ flex: 1 }}>← Back</Btn>
          {isMine && (
            <>
              <Btn disabled={busy} onClick={toggleSold} style={{ flex: 1 }}>{listing.status === "sold" ? "Reactivate" : "Mark Sold"}</Btn>
              <Btn variant="danger" onClick={() => setConfirming(true)} style={{ flex: 1 }}>Remove</Btn>
            </>
          )}
        </div>
      )}
      <div style={{ height: 20 }} />
    </div>
  );
}
